import { render, staticRenderFns } from "./IssueReportsReadOnly.vue?vue&type=template&id=010d4db4&scoped=true&"
import script from "./IssueReportsReadOnly.vue?vue&type=script&lang=js&"
export * from "./IssueReportsReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportsReadOnly.vue?vue&type=style&index=0&id=010d4db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d4db4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010d4db4')) {
      api.createRecord('010d4db4', component.options)
    } else {
      api.reload('010d4db4', component.options)
    }
    module.hot.accept("./IssueReportsReadOnly.vue?vue&type=template&id=010d4db4&scoped=true&", function () {
      api.rerender('010d4db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/IssueReportsReadOnly.vue"
export default component.exports